import styled from 'styled-components'

export const FormContainer = styled.div`
  width: 100%;
  padding: 16px;

  > h5 {
    margin-bottom: 15px;

    > button {
      margin-right: 10px;
    }
  }
`

export const FieldWrapper = styled.div`
  margin-bottom: 0.5rem;
`
